import React, {useEffect, useState} from "react";
import {Navigate, Route, Routes} from "react-router-dom";
import "./Cows.scss";
import {CowsMenu} from "./CowsMenu/CowsMenu";
import {TicketsTopics} from "./CowsLocations";
import {Cows} from "./Cows";
import {ButtonIcon, useLocalStorage} from "@vokymlak/kabinet-ui";

export const CowsRouting = () => {
  const [cowsSetting, setCowsSetting] = useLocalStorage("cows", {
    isHiddenMenu: false,
  });

  const [isHiddenMenu, setIsHiddenMenu] = useState(cowsSetting.isHiddenMenu || false);

  useEffect(() => {
    setCowsSetting({
      isHiddenMenu,
    });
  }, [
    isHiddenMenu,
  ]);

  return (
    <div className="Cows">
      <div className="Block">
        <div className="App App_vertical">
          <div className="Navigate" style={{
            width: !isHiddenMenu ? 320 : 28,
          }}>
            {!isHiddenMenu && (
              <CowsMenu setIsHiddenMenu={setIsHiddenMenu} isHiddenMenu={isHiddenMenu}/>
            )}
            {isHiddenMenu && (<>
              <div
                  style={{
                    position: "absolute",
                    top: 20,
                    left: -24
                  }}
                >
                  <ButtonIcon
                    iconName={"custom-circle-arrow-right"}
                    iconColor={"#20202075"}
                    size={24}
                    style={{left: 24}}
                    onClick={() => setIsHiddenMenu(!isHiddenMenu)}
                  />
                </div>
            </>)}
          </div>

          <div className="Content" style={{
            borderLeft: "2px solid #20202015",
          }}>
            <Routes>
              <Route
                path="/location/:cowLocationUuid"
                element={<Cows/>}
              />

              <Route
                path="/all"
                element={<Cows isCount={true}/>}
              />

              <Route
                path="/no-location"
                element={<Cows isLocationNull={true}/>}
              />

              <Route
                path="/bull"
                element={<Cows typeTag={"BULL"}/>}
              />

              <Route
                path="/cow"
                element={<Cows typeTag={"COW"}/>}
              />

              <Route
                path="/netel"
                element={<Cows typeTag={"NETEL"}/>}
              />

              <Route
                path="/heifer"
                element={<Cows typeTag={"HEIFER"}/>}
              />

              <Route
                path="/steer"
                element={<Cows typeTag={"STEER"}/>}
              />

              <Route
                path="/dropped"
                element={<Cows isDropped={true}/>}
              />

              <Route path="/locations" element={<TicketsTopics/>}/>
              <Route exact path="/" element={<Navigate to="./all" replace/>}/>
            </Routes>
          </div>
        </div>
      </div>
    </div>
  );
};
